// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CartProvider } from './context/CartContext';
import { SettingsProvider } from './context/SettingsContext';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_live_51RBfgtRu4UskukJYIeFwfd4FF5JTlHTFlWwAhAgVr7ZWSXrffelaE86S9amm5NbAUohNGIsMQIVH7Wv7C7Utz8nu00nAcPYzBH');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <HelmetProvider>
        <SettingsProvider>
          <CartProvider>
            <Elements stripe={stripePromise}>
              <App />
            </Elements>
          </CartProvider>
        </SettingsProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </BrowserRouter>
);
